import { Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';

@Directive( {
  selector: '[appSecurePhone]'
} )
export class SecurePhoneDirective implements OnChanges {

  @Input() appSecurePhone: string;

  constructor ( private el: ElementRef,  private renderer: Renderer2 ) {}

  ngOnChanges () {
    this.renderer.setAttribute(
      this.el.nativeElement,
      'href',
      `sip:${this.appSecurePhone}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/secure-phone.directive.ts